import { Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GetSearchContainersByTerminalParams } from '../../../global/adapters/crpAPI';
import StepUseCase from '../../../global/components/Stepper/StepUseCase';
import TerminalYardSearchStep from '../shared/TerminalYardSearchStep';
import { FormikErrors } from 'formik';
import { useGetActiveShippingAgents } from 'modules/release-party/adapters/search-containers/queries';
import { LABEL } from 'theme/constants';

type Props = {
  isFetching?: boolean;
  resetForm: VoidFunction;
  submitForm: VoidFunction;
  values: GetSearchContainersByTerminalParams;
  errors: FormikErrors<GetSearchContainersByTerminalParams>;
  onResetSearch: VoidFunction;
};

const StepperSearchContainers = ({
  isFetching,
  resetForm,
  submitForm,
  values,
  errors,
  onResetSearch,
}: Props) => {
  const { t } = useTranslation(['common', 'useCase', 'validation']);

  const resetFormAndValues = () => {
    resetForm();
    onResetSearch();
  };

  const {
    data: shippingAgents,
    isFetching: isFetchingAgents,
    isError: isErrorAgents,
  } = useGetActiveShippingAgents();

  const equipmentNumberError = Boolean(errors.equipmentNumber);
  const shippingAgentNxtEntityIdError = Boolean(errors.shippingAgentNxtEntityId);
  const billOfLadingNumberError = Boolean(errors.billOfLadingNumber);
  const vesselNameError = Boolean(errors.vesselName);
  const imoNumberError = Boolean(errors.imoNumber);
  const stayNumberError = Boolean(errors.stayNumber);

  const hasValidationError =
    equipmentNumberError ||
    shippingAgentNxtEntityIdError ||
    billOfLadingNumberError ||
    vesselNameError ||
    imoNumberError ||
    stayNumberError;

  const {
    shippingAgentNxtEntityId,
    equipmentNumber,
    billOfLadingNumber,
    vesselName,
    imoNumber,
    stayNumber,
  } = values;
  const searchAvailable =
    Boolean(shippingAgentNxtEntityId && shippingAgentNxtEntityId !== LABEL.UNKNOWN) ||
    Boolean(equipmentNumber) ||
    Boolean(billOfLadingNumber) ||
    Boolean(vesselName) ||
    Boolean(imoNumber) ||
    Boolean(stayNumber);

  return (
    <Paper sx={{ p: 2, minWidth: 0, overflow: 'visible' }}>
      <StepUseCase
        activeStep={0}
        steps={[
          {
            stepTitle: t('common:general.search'),
            stepFlavorText: t('useCase:containers.searchContainersFlavorText'),
            backCallBack: resetFormAndValues,
            nextCallBack: submitForm,
            backCustomText: t('common:general.reset'),
            nextCustomText: isFetching
              ? t('useCase:containers.loadingContainers')
              : t('useCase:containers.searchContainers'),
            nextIsLoading: isFetching,
            content: (
              <TerminalYardSearchStep
                shippingAgents={shippingAgents}
                hasValidationError={hasValidationError}
                validationMessage={t('validation:atLeastOneField')}
                isFetching={isFetchingAgents}
                isError={isErrorAgents}
              />
            ),
            disableNext: !searchAvailable,
          },
        ]}
      />
    </Paper>
  );
};
export default StepperSearchContainers;
